import { Injectable } from '@angular/core';
import { ApicallService } from '../services/apicall.service';

@Injectable({
  providedIn: 'root'
})
export class PermissionService {

  permissionArray: any = this.apiCallService.permissions;

  constructor(
    public apiCallService: ApicallService
  ) { }

  getPermission(expectedPermissionArray){
    if(this.apiCallService.permissions == undefined){
      return false;
    }
    this.permissionArray = this.apiCallService.permissions;
    for (let i = 0; i < expectedPermissionArray.length; i++) {
      for (let j = 0; j < this.permissionArray.length; j++) {
        if (expectedPermissionArray[i] == this.permissionArray[j]) {
          return true;
        }
      }
    }
    return false;
    
  }


}
